function EmptyLegsPage() {
  return (
    <div className="inner-page">
      <section className="inner-page-hero" style={{ '--inner-hero-image': "url('/assets/empty-legs.jpg')" }}>
        <p className="inner-page-eyebrow">Opportunity Board</p>
        <h1>See Empty Legs</h1>
        <p>This page is ready for your empty-leg listings.</p>
      </section>

      <section className="page-shell">
        <div className="panel-card panel-card--blank" />
      </section>
    </div>
  );
}

export default EmptyLegsPage;
